export default __webpack_public_path__ + "static/media/Arrow Line_Right Large Copy 11.6d0d05fb.svg";